import { FC } from "react";
import { TableRoomsCellItem } from "./TableRoomsCellItem";
import { IPlacementWorksheetUnitOccupant } from "../../services/PlacementWorksheetApi";
import { usePopupContext } from "../../contexts/PopupContext/context";
import { Button } from "../../UI/Button";
import { usePlacementWorksheetSettingsContext } from "../../contexts/PlacementWorksheetContext";
import { PlacementWorksheetConfirmWorksheetModal } from "../PlacementWorksheetConfirmWorksheetModal";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useMatchHandler } from "../PlacementWorksheetConfirmWorksheetModal/useMatchHandler";
import useAuth from "../../routes/login/AuthContext";

interface ITableRoomsCellProps {
  unitId: number;
  residents: IPlacementWorksheetUnitOccupant[];
  matchGroupAtLimit: boolean;
  isReadOnly?: boolean;
}

export const TableRoomsCell: FC<ITableRoomsCellProps> = ({ residents, unitId, matchGroupAtLimit, isReadOnly }) => {
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();
  const { selectedResidents } = usePopupContext();
  const { labels } = usePlacementWorksheetSettingsContext();
  const { handleMatch, isLoading } = useMatchHandler(unitId, residents);

  const residentWithOutRoom = residents?.filter((resident) => resident && resident.roomLabelId == null) || [];

  const emptySpaceLeft = (labels?.length || 0) - (residents?.length || 0);

  const onAssignClick = async () => {
    if (residents?.length) {
      setIsOpen(true);
    } else {
      await handleMatch();
    }
  };

  return (
    <>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '8px', width: '134px', padding: '4px 4px 4px 8px', maxWidth: '134px', boxSizing: 'border-box' }}>
        {residentWithOutRoom.map((resident) => (
          <TableRoomsCellItem key={resident.id} unitId={unitId} resident={resident} />
        ))}
      </div>
      {!!selectedResidents?.length && !isReadOnly && (
        <>
          <Button
            appearance="primary"
            isLoading={isLoading}
            onClick={onAssignClick}
            isDisabled={emptySpaceLeft < selectedResidents.length || isSuperAdminRead()}
          >
            Assign To Row
          </Button>
          <PlacementWorksheetConfirmWorksheetModal unitResidents={residents} unitId={unitId} matchGroupAtLimit={matchGroupAtLimit} />
        </>
      )}
    </>
  );
};
